import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fructidor/fructidor-ui/releases/20250410113957/app/[lng]/(home)/about-us/Testimonial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/opt/fructidor/fructidor-ui/releases/20250410113957/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/opt/fructidor/fructidor-ui/releases/20250410113957/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/fructidor/fructidor-ui/releases/20250410113957/node_modules/next/dist/client/link.js");
